import { useEffect, useState } from "preact/hooks";
import {
  buySpaces,
  canBuySpaces,
  puzzle,
  spacesPurchased,
  status,
} from "../game/state";

const FADE_MS = 300;

/** The "Reveal Spaces" button. Returns null in states where the button
    shouldn't render (no puzzle, post-purchase, game-over, or once the
    affordability fade-out has finished). Unlike Hint, Spaces has no
    text payload — the structural reveal on the board IS the feedback,
    so there's no parallel "display" component. The parent
    (`<TopBar />`) reserves the row's height. */
export function Spaces() {
  const p = puzzle.value;
  const playing = status.value === "playing";
  const purchased = spacesPurchased.value;
  const canBuy = canBuySpaces.value;

  // Hooks must run unconditionally — declare them BEFORE any early
  // return. Mirror Hint.tsx's cross-fade lifecycle so the button
  // disappears smoothly when affordability drops below threshold.
  const [buttonMounted, setButtonMounted] = useState(canBuy);
  const fading = buttonMounted && !canBuy;

  useEffect(() => {
    if (canBuy && !buttonMounted) {
      setButtonMounted(true);
      return;
    }
    if (!canBuy && buttonMounted) {
      const t = setTimeout(() => setButtonMounted(false), FADE_MS);
      return () => clearTimeout(t);
    }
    return;
  }, [canBuy, buttonMounted]);

  if (p == null) return null;
  if (!playing) return null;
  if (purchased) return null;
  if (!buttonMounted) return null;

  return (
    <button
      type="button"
      class={`hint__button${fading ? " hint__button--fade" : ""}`}
      onClick={() => buySpaces()}
      disabled={!canBuy}
      aria-label="Reveal spaces (costs 3 guesses)"
    >
      Reveal Spaces <span class="hint__cost">(costs 3 guesses)</span>
    </button>
  );
}
